export default "__VITE_ASSET__CZKLKLpP__"